// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"670":"bc67498c","718":"c3ed6728","735":"bc67498c"}[chunkId] + ".chunk.css";
};